import { Patient } from '../../models/patient';
import client from '../httpclient';

const updatePatientDetails = (
  patientId: string,
  data: Partial<Patient>,
): Promise<Patient> => client.put(`/re/v1/patient/${patientId}`, {
  ...data,
});

export default updatePatientDetails;
